// @flow
import React from 'react';
import { SelectHookForm } from 'bench-internal-theme';
import useCurrency from './useCurrency';
import { getCurrencyOptions } from './formOptions';

type CurrencySelectContainerProps = {
  currencyId: ?string,
  rules?: any,
};

const CurrencySelect = ({ currencyId, rules }: CurrencySelectContainerProps) => {
  const { currencies, hasError, isLoading, clientCurrencyIdDefault } = useCurrency();
  const options = getCurrencyOptions(currencies);

  return (
    <SelectHookForm
      aria-label="Currency"
      defaultValue={currencyId || clientCurrencyIdDefault}
      isDisabled
      isLoading={isLoading}
      name="currencyId"
      options={options}
      placeholder={hasError && 'A problem occurred fetching currencies'}
      rules={rules}
    />
  );
};

CurrencySelect.defaultProps = {
  rules: undefined,
};

export default CurrencySelect;
